import { NgModule } from '@angular/core';

import { HasPrviageDirective } from './directives/has-permission.directive';
import { DraggableDirective } from './directives/draggable.directive';

@NgModule({
    imports: [],
    declarations: [HasPrviageDirective, DraggableDirective],
    exports: [HasPrviageDirective, DraggableDirective]
})
export class DirectivesModule { }